import { flowTypes, pageConfig } from '@/common/service/page-config';
import { planTypes, BASE_PLAN_SUB_TYPES } from '@/common/constants';
import store from '@/store';
import qs from 'qs';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { $context } from '@/global-install/index';
import { plansof } from '@/utils/chain';
import { get } from 'lodash';
import { AllPlans } from '@/plans';
import { getLookupRouterParams } from '@/common/service/lookup-params';
const handleMixMatchCase = ({ flow, type }) => {
  const { getSelectedPlans = [] } = store.getters;
  if ([flowTypes.buyNow, flowTypes.basic2pro].includes(flow)) {
    // standalone
    const targetPlan = getSelectedPlans?.find?.(p => p.type === type) ?? {};
    const { standAlone = false } = targetPlan;
    const dependPlanTypeList = get(targetPlan, 'dependBasePlanTypeList', []);
    const isPro = window.$config('plan') === BASE_PLAN_SUB_TYPES.PRO;
    const hasMeetingPlan = plansof(getSelectedPlans).type(planTypes.ZOOM_MEETING).has();
    if ((standAlone || dependPlanTypeList.includes(planTypes.ZOOM_MEETING)) && isPro && hasMeetingPlan) return true;
    if (MIX_MATCH_PLAN_TYPES.includes(type) && hasMeetingPlan) return true;
  }
  return false;
};

// eslint-disable-next-line no-unused-vars
const isEligibleForNewConfirmationPage = ({ query, flow, type }) => {
  // OP feature flag
  if (!window?.campaignFlags?.isShowNewSuccessPage) return false;
  // fix issue: ZOOM-735499
  // if only optimizely is enabled, return false to goto legacy success page
  // if OPC modal iframe case, goto new success page
  if (window !== window.top && !window?.$context?.is?.modal) return false;

  let planType = type;
  if (!type) {
    const { getCurrentBasePlanInfo } = store.getters;
    planType = getCurrentBasePlanInfo.planType;
  }
  const eligiblePlanTypes = AllPlans.filter(plan => plan?.components?.success).map(plan => plan.key);
  if (eligiblePlanTypes.includes(planTypes[planType])) return true;
  return false;
};

export const proceedPayNowUrlFn = (query, url, target = '_post') => {
  const { type, flow } = window.$context;
  console.log('proceedPayNowUrlFn', type, flow);
  setShoppingCartElePersist({ flow, type });
  setShoppingCartPersist();
  if (target === '_self') {
    return () => window.location.href = `${url}`;
  }
  return (postParams) => window.SB?.postForm(`${url}`, postParams);
};

export const getSuccessPageUrlFn = (_query, url, target = '_post') => {

  // relay params from current url to target url
  let query = _query;
  try{
    const relayQueries = [
      "ref",
    ];
    const curQueryObj = qs.parse(window.location.search.slice(1));
    const relayQueryObj = relayQueries.reduce((acc, x)=>{
      if(curQueryObj[x]){
        acc[x] = curQueryObj[x];
      }
      return acc;
    }, {})
    let appending = qs.stringify(relayQueryObj);
    if(appending.length) appending = "&" + appending;
    query = `${_query}${appending}`
  }catch(e){console.log(e)}

  const { type, flow } = window.$context;
  console.log('getSuccessPageUrl', type, flow);
  setShoppingCartElePersist({ flow, type });
  setShoppingCartPersist();
  const flag = isEligibleForNewConfirmationPage({ query, flow, type });
  const jointsale = window.$query?.jointsale;
  const partnerQuery = jointsale ? `&jointsale=${jointsale}` : ''

  // LOOKUP router (Add lookup router params to the exit of the success page)
  const lookupRouterParams = getLookupRouterParams();

  if (flag) {
    return (postParams = {}) => window.SB?.postForm?.(`/opc/buy/success?${query}${partnerQuery}`, {
      ...lookupRouterParams,
      ...postParams,
      uniqueKey: store.getters.transactionId,
    });
  }
  if (target === '_self') {
    return (postParams = {}) => jumpToConfirmation({
      ...lookupRouterParams,
      ...postParams,
      uniqueKey: store.getters.transactionId,
    },`${url}&flag=${flag ? 'new' : 'legacy'}${partnerQuery}`);
  }
  return (postParams = {}) => window.SB?.postForm?.(`${url}&flag=${flag ? 'new' : 'legacy'}${partnerQuery}`, {
    ...lookupRouterParams,
    ...postParams,
    uniqueKey: store.getters.transactionId,
  });
};

const jumpToConfirmation = (postParams, url) => {
  const coppa = postParams?.coppa;
  if (coppa) {
    window.location.href = `${url}&coppa=${coppa}`;
  } else {
    window.location.href = `${url}`;
  }
}

export const setShoppingCartPersist = (params = {}) => {
  const { getters } = store;
  store.commit('setConfirmationDetails', {
    getSelectedPlans: getters.getSelectedPlans,
    boughtPlans: getters.boughtPlans.map(p => ({
      quantity: p.cartInfo.selected_number,
      planCode: p.plan_code,
      type: p.type,
      billingCycle: p.billing_cycle,
    })),
    isPrecise: getters.isPrecise,
    discountWithAmountMap: getters.discountWithAmountMap,
    onSessionPaymentEnabled: getters.onSessionPaymentEnabled,
    openInvoiceState: {
      openInvoiceList: getters.openInvoiceList,
      openInvoiceTotalAmount: getters.openInvoiceTotalAmount,
      openInvoiceOriginalTotalAmount: getters.openInvoiceOriginalTotalAmount,
      getterCurrentCreditBalance: getters.getterCurrentCreditBalance,
    },
    ...params
  });
};

export const setShoppingCartElePersist = ({ flow, type }) => {
  const { cartEle, firstPlanTitleEle, firstPlanSubtitleEle, firstPlanDiscountEle, totalEle, submitEle } = getOrderSummaryInnerHtml();
  store.commit('setConfirmationDetails', {
    cartEle,
    firstPlanTitleEle,
    firstPlanSubtitleEle,
    firstPlanDiscountEle,
    isMixMatchCase: handleMixMatchCase({ flow, type }),
    totalEle,
    submitEle,
  });
};

export const getOrderSummaryInnerHtml = () => {
  // order details
  const cartEle = document.querySelector('.__PLACEHOLDER_cart__');
  // total
  const totalEle = document.querySelector('.__PLACEHOLDER_total__');
  const submitEle = document.querySelector('.__PLACEHOLDER_submit__'); // submit label
  if (cartEle) {
    const firstPlanTitleEle = cartEle.querySelector('.__PLACEHOLDER_first_title__');
    const firstPlanTitleEleParentNode = firstPlanTitleEle?.parentElement;
    const firstPlanSubtitleEle = firstPlanTitleEleParentNode && firstPlanTitleEleParentNode.querySelector('.__PLACEHOLDER_sub_title__');
    const firstPlanDiscountEle = cartEle.querySelector('.__PLACEHOLDER_discount_title__');
    return {
      cartEle: cartEle.innerHTML,
      firstPlanTitleEle: firstPlanTitleEle?.outerHTML,
      firstPlanSubtitleEle: firstPlanSubtitleEle?.outerHTML,
      firstPlanDiscountEle: firstPlanDiscountEle?.innerHTML,
      totalEle: totalEle?.innerHTML,
      submitEle: submitEle?.innerHTML,
    }
  }
}

export const replaceELement = (temp, targetClass, text) => {
  const targetEle = temp.querySelector(targetClass);
  if (targetEle) {
    targetEle.innerHTML = text;
  }
}

export const replaceELementByCallback = (temp, targetClass, callback = () => {}) => {
  const targetEle = temp.querySelector(targetClass);
  if (targetEle) {
    callback(targetEle);
  }
}

export const removeElementByIndex = (temp, targetClass, index) => {
  const targetEles = [...temp.querySelectorAll(targetClass)];
  if (targetEles.length) {
    const targetEle = targetEles[index < 0 ? targetEles.length + index : index];
    targetEle?.remove?.();
  }
}

export const removeElements = (eles) => {
  if (!Array.isArray(eles)) return;
  eles.forEach(e => {
    e?.remove?.();
  });
}

export const PROMOTES_ADDON_PLAN_TYPES = [
  planTypes.ZOOM_SCHEDULER,
  planTypes.LARGE_MEETING,
  planTypes.CMR,
  planTypes.TRANSLATION_CAPTIONS,
  planTypes.WEBINAR,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.TOLLFREE,
];

export const MIX_MATCH_PLAN_TYPES = [
  planTypes.ZOOM_ONE_BUNDLE,
  planTypes.ZOOM_SCHEDULER,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.ZOOM_WHITEBOARD_PLUS,
  planTypes.ROOM_CONNECTOR,
  planTypes.WEBINAR,
  planTypes.EVENT_SAAS,
  planTypes.EVENT_SAAS_CORE,
  planTypes.TOLLFREE,
  planTypes.CMR,
  planTypes.LARGE_MEETING,
  planTypes.TRANSLATION_CAPTIONS,
  planTypes.TOLLFREE$DID,
  planTypes.ZOOM_ROOMS,
  planTypes.ZOOM_DOCS,
];

export const getSuccessPlanKey = () => {
  let type = $context.type || getPlanTypeByCategory(pageConfig.editConfig.plan || pageConfig.editConfig.category);
  if (!type) {
    const { getCurrentBasePlanInfo } = store.getters;
    type = getCurrentBasePlanInfo.planType;
  }
  if (store?.getters?.persistState?.confirmationDetails?.isMixMatchCase) {
    return planTypes[planTypes.ZOOM_MEETING];
  }
  return planTypes[type];
};

export const getApmFlowType = () => {
  const apmFlowType = store?.getters?.persistState?.confirmationDetails?.opcFlowTypeWhenApm;
  const isAPM = !!(store?.getters?.persistState?.confirmationDetails?.isAPM)
  if (isAPM && Object.values(flowTypes).includes(apmFlowType)) {
    return apmFlowType;
  }
  return $context.flow;
};

const WHITEBOARED_URL_PLAN_CODE = 'z1s';
const VIDEO_SDK_URL_PLAN_CODE = 'litesdk';

// For more PLAN_CATEGORY_CODE see the java project billing-commons-dto com.saasbee.webapp.billing.enums.ServiceCategoryCode
export const PLAN_CATEGORY_CODES = {
  PRO: 'PRO',
  BUSINESS: 'BIZ',
  CLOUD_STORAGE: 'CMR',
  WEBINAR: 'WBN',
  LARGE_MEETING: 'LMT',
  WHITEBOARD: 'ZWB',
  TRANSLATED_CAPTIONS: 'ZTRANSL',
  ZOOM_SCHEDULER: 'ZSCHED',
  ZOOM_EVENTS: 'ZET',
  ZOOM_SESSIONS: 'ZETZEC',
  ZOOM_ROOMS: 'ZRM',
  TOLLFREE: 'ADR',
  ZOOM_PHONE: 'ZMV',
  CONFERENCE_ROOM_CONNECTOR: 'RCN',
  ZOOM_ONE_BIZ_PLUS: 'ZONEBIZP',
  ZOOM_ONE_PRO_PLUS: 'ZONEPROP',
  ZOOM_CLIPS_PLUS: 'ZCLIPS',
  BASIC_PLUS: 'ZOBASICP',
  LDKCMR: 'LDKCMR',
  ZOOM_REVENUE_ACCELERATOR: 'ZKW',
};

export const FLOW_URL = {
  EDIT: {
    LEGACY: '/account/billing/buy',
    OPC: '/opc/buy/edit',
  },
  ADD: {
    LEGACY: '/account/billing/buy',
    OPC: '/opc/buy/add',
  },
  UPGRADE: {
    LEGACY: '/account/billing/upgrade',
    OPC: '/opc/buy/upgrade',
  },
};

// Add to cart
const ADD_TO_CART_URL_PARAM = {
  PLAN: 'plan',
  SUB_PLAN: 'subPlan',
  FROM_SUB: 'from_sub',
  TYPE: 'type',
  MAJOR_PLAN_HOST: 'majorPlanHost',
};
// edit
const EDIT_URL_PARAM = {
  PLAN: 'plan',
  SUB_PLAN: 'subPlan',
  TYPE: 'type',
  OLD_PLAN_CODE: 'oldPlanCode',
  OLD_HOSTS: 'oldHosts',
  MAJOR_PLAN_HOST: 'majorPlanHost'
}

export const FLOW_TYPE = {
  EDIT: 'edit',
  UPGRADE: 'upgrade',
  ADD: 'add',
  TRIAL_TO_PAID: 'trial2paid',
  ADD_TRIAL: 'add_trial',
};

export const PLAN_TYPES = {
  FREE_BASIC: 'free_basic',
  WEBINAR: 'webinar',
  CMR: 'cmr',
  LARGE_MEETING: 'large',
  ZOOM_MEETING: 'zoom_meeting',
  ZOOM_EVENTS: 'zoom_events',
  ZOOM_PHONE: 'pbx',
  ZOOM_ROOMS: 'zr',
  TRANSLATION_CAPTIONS: 'translation_captions',
  ZOOM_ONE: 'pro',
  TEAM_CHAT: 'team_chat',
  MAIL: 'mail',
  CALENDAR: 'calendar',
  ZOOM_WHITEBOARD: 'whiteboard',
  ROOM_CONNECTOR: 'rc',
  TOLLFREE: 'tollfree',
  API: 'api',
  ZOOM_UNITED: 'zoomunited',
  VIDEO_SDK: 'video_sdk',
  ZOOM_HARDWARE: 'zoom_hardware',
  HEALTHCARE_AGREEMENT: 'hipaa_compliance',
  PREMIER: 'premier',
  PAID_DEVELOPER: 'paid_developer',
  WEBINAR_PROMO: 'webinar_promo',
  FREE_TRIAL: 'free_trial',
  QSS: 'quality_streaming_service',
  ZOOM_NODE: 'zoom_node',
  ZOOM_CONTACT_CENTER: 'zcc',
  PHONE_NUMBER: 'pnm',
  ZOOM_IQ: 'zoom_iq',
  MIO: 'mio',
  ZOOM_CHAT: 'zoom_chat',
  ZOOM_ONE_BUNDLE: 'zonebundle',
  TRANSLATION: 'translation',
  VIDEO_SDK_TRANSLATION: 'videosdk_tt',
  ZOOM_ROOM_HARDWARE: 'zr_hardware',
  ZOOM_PHONE_HARDWARE: 'pbx_hardware',
  WORKSPACE_RESERVATION: 'workspace_reservation',
  CMK: 'cmk',
  LDKCMR: 'videosdk_cmr',
  Bundle_CREDIT: 'bundleCredit',
  ZOOM_MESH: 'zoom_mesh',
  ZVA: 'zva',
  EVENT_SAAS: 'eventsaas',
  EVENT_SAAS_CORE: 'eventsaascore',
  ADDITIONAL_HOST: 'additional_host',
  ADDITIONAL_CO_EDITOR: 'additional_co_editor',
  EVENTS_UNLIMITED_ADDITIONAL_HOST: 'eventsaas-additionalhost',
  EVENTS_UNLIMITED_ADDITIONAL_CO_EDITOR: 'eventsaas-additionalcoeditor',
  SESSIONS_UNLIMITED_ADDITIONAL_HOST: 'eventsaascore-additionalhost',
  SESSIONS_UNLIMITED_ADDITIONAL_CO_EDITOR: 'eventsaascore-additionalcoeditor',
  API_CSP: 'api_csp',
  LDKCRC: 'video_sdk_crc',
  ZOOM_SPOTS: 'zoom_spots',
  WORKFORCE_ENGAGEMENT: 'workforce_engagement',
  ZSU: 'ZSU',
  PNM: 'pnm',
  ZOOM_COMMON: 'common',
  VIDEO_SDK_SESSION: 'LDP',
  VIDEO_SDK_CLOUD_RECORDING: 'videosdk_cmr',
  VIDEO_SDK_TRANSLATION_TRANSCRIPTION: 'ZVDKTT',
  AUDIO_CONFERENCING: 'ADP',
  VIDEO_SDK_CLOUD_ROOM_CONNECTOR: 'videosdk_crc',
  WEBINAR_SESSIONS: 'ZECSU',
  ZOOM_SCHEDULER: 'zsched',
  ZONE_BASIC_PLUS: 'zone_basic_plus',
  ZOOM_EVENTS_PPA: 'eventsaas_consumption',
  ZOOM_SESSIONS_PPA: 'eventsaascore_consumption',
  CONFERENCE_ROOM_CONNECTOR: 'roomconnector',
  ZOOM_CLIPS: 'clips',
  ZOOM_NOTES: 'notes',
  AI_COMPANION: 'ai',
  VIDEO_SDK_BUNDLE_CREDIT: 'uc',
  ZOOM_ONE_BIZ_PLUS: 'zone_bizplus',
  ZOOM_ONE_PRO_PLUS: 'zone_proplus',
  ZOOM_CLIPS_PLUS: 'zclips',
  VISITOR_MANAGEMENT: 'zvstmgt',
  ZOOM_REVENUE_ACCELERATOR: 'zoom_revenue_accelerator',
  CUSTOM_AVATARS: "custom_avatars"
};

export function getAdd2CartUrl(type) {
  const basePlanInfoObj = store.getters.getBoughtBasePlanInfo;

  function getPlan() {
    if ([PLAN_TYPES.ZOOM_PHONE, PLAN_TYPES.ZOOM_ROOMS].includes(basePlanType)) {
      return basePlanType;
    } else if (
      basePlanType === PLAN_TYPES.ZOOM_WHITEBOARD &&
      (type === PLAN_TYPES.ZOOM_WHITEBOARD || parentCategoryCode === PLAN_CATEGORY_CODES.WHITEBOARD)
    ) {
      return WHITEBOARED_URL_PLAN_CODE;
    } else if (
      // Zoom Meeting Edu self OR Edu sub plans
      (type === PLAN_TYPES.ZOOM_MEETING || basePlanType === PLAN_TYPES.ZOOM_MEETING) &&
      parentCategoryCode.toLowerCase() === BASE_PLAN_SUB_TYPES.EDU.toLowerCase()
    ) {
      return BASE_PLAN_SUB_TYPES.EDUCATION.toLowerCase();
    } else if (PLAN_TYPES.VIDEO_SDK === basePlanType) {
      return VIDEO_SDK_URL_PLAN_CODE;
    } else if (basePlanType === PLAN_TYPES.ZOOM_ONE_BIZ_PLUS) {
      return BASE_PLAN_SUB_TYPES.BIZ;
    } else if (basePlanType === PLAN_TYPES.ZOOM_ONE_PRO_PLUS) {
      return BASE_PLAN_SUB_TYPES.PRO;
    } else if (basePlanType === PLAN_TYPES.ZOOM_UNITED) {
      return parentCategoryCode.replace(/^uc/i, '').toLowerCase();
    } else if (basePlanType === PLAN_TYPES.ZOOM_CLIPS_PLUS) {
      return WHITEBOARED_URL_PLAN_CODE;
    }
    return parentCategoryCode.toLowerCase();
  }

  function getFromSub() {
    return type === PLAN_TYPES.ZOOM_MEETING ? PLAN_TYPES.ZOOM_ONE : PLAN_TYPES[type];
  }

  if (!basePlanInfoObj) {
    return '';
  }
  const { plans: basePlanInfo } = basePlanInfoObj;
  if (!basePlanInfo?.[0]) {
    return '';
  }
  const { type: basePlanType, parent_category: parentCategoryCode, cartInfo } = basePlanInfo?.[0];

  const queryObj = {
    [ADD_TO_CART_URL_PARAM.PLAN]: getPlan(),
    [ADD_TO_CART_URL_PARAM.SUB_PLAN]: 'newsubs',
    [ADD_TO_CART_URL_PARAM.FROM_SUB]: getFromSub(),
    [ADD_TO_CART_URL_PARAM.TYPE]: FLOW_TYPE.ADD,
    [ADD_TO_CART_URL_PARAM.MAJOR_PLAN_HOST]: basePlanType === planTypes.VIDEO_SDK ? 0 : cartInfo.selected_number,
  };
  return (
    FLOW_URL.ADD.OPC +
    '?' +
    qs.stringify(queryObj)
  );
}
// Please note:
// This method(getEditUrl) only support:
// 1. Base plan is Meeting plan, editPlan is Whiteboard Plus
export function getEditUrl(basePlanInfo, editPlanInfo) {
  const queryObj = {
    [EDIT_URL_PARAM.PLAN]: (() => {
      if (basePlanInfo) {
        const isBiz = basePlanInfo.type === planTypes.ZOOM_MEETING && basePlanInfo.category === BASE_PLAN_SUB_TYPES.BIZ;
        const isBizPlus = basePlanInfo.type === planTypes.ZOOM_ONE_BUNDLE && basePlanInfo.sub_type === BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS;
        if (isBiz || isBizPlus) {
          return BASE_PLAN_SUB_TYPES.BIZ;
        }
      }
      return basePlanInfo.category;
    })(),
    [EDIT_URL_PARAM.SUB_PLAN]: editPlanInfo.type,
    [EDIT_URL_PARAM.TYPE]: FLOW_TYPE.EDIT,
    [EDIT_URL_PARAM.OLD_PLAN_CODE]: editPlanInfo?.plan_code,
    [EDIT_URL_PARAM.OLD_HOSTS]: editPlanInfo?.cartInfo?.selected_number,
    [EDIT_URL_PARAM.MAJOR_PLAN_HOST]: basePlanInfo?.cartInfo?.selected_number
  }

  return FLOW_URL.EDIT.OPC + '?' + qs.stringify(queryObj)
}

